import _ from 'lodash'

export default {
  groupedByAncestors (state) {
    let grouped = []
    if (state.reportQuery.reportType === 'general') grouped = _.groupBy(state.result, 'ancestors')

    return grouped
  },
  groupedByItems (state) {
    let result = {}

    if (state.reportQuery.reportType === 'photos' && state.result) {
      // Function that merges the same items
      const picturesGroup = _.groupBy(state.result.pictures, 'item_id')
      const addonsGroup = _.groupBy(state.result.addons, 'item_id')

      state.result.items.forEach(item => {
        if (picturesGroup[item.id] && addonsGroup[item.id]) {
          // Here we concat the arrays of pictures and addons
          result[item.id] = picturesGroup[item.id].concat(addonsGroup[item.id])
        } else {
          // If there is only one array, we just add it to the result
          result[item.id] = picturesGroup[item.id] ? picturesGroup[item.id] : addonsGroup[item.id]
        }
      })
    }
    return result
  }
}
